'use client';

import { c as _c } from "react/compiler-runtime";
import { TERM_CATEGORY } from '@/api';
import { CustomLink } from '@/app/_components/CustomLink';
import { ROUTES } from '@/constants';
import { useGlobalStore } from '@/stores/GlobalStore';
interface PolicyInfoProps {
  onOpenTerms?: () => void;
}
export const PolicyInfo = t0 => {
  const $ = _c(18);
  const {
    onOpenTerms
  } = t0;
  const setTermsDrawerType = useGlobalStore(_temp);
  let t1;
  if ($[0] !== onOpenTerms || $[1] !== setTermsDrawerType) {
    t1 = termCategory => {
      onOpenTerms?.();
      setTermsDrawerType(termCategory);
    };
    $[0] = onOpenTerms;
    $[1] = setTermsDrawerType;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleOpenTerms = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="pb-8 font-700 text-Gray-600 typo-body4">정책 및 법률</p>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <li><CustomLink href={ROUTES.MY_NOTICE} aria-label={"\uACF5\uC9C0\uC0AC\uD56D \uD398\uC774\uC9C0\uB85C \uC774\uB3D9"}>공지사항</CustomLink></li>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== handleOpenTerms) {
    t4 = <li><button type="button" onClick={() => handleOpenTerms(TERM_CATEGORY.SERVICE_TERMS)}>이용약관</button></li>;
    $[5] = handleOpenTerms;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== handleOpenTerms) {
    t5 = <li><button className="font-700 text-B-500 underline" type="button" onClick={() => handleOpenTerms(TERM_CATEGORY.PRIVACY_POLICY)}>개인정보처리방침</button></li>;
    $[7] = handleOpenTerms;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== handleOpenTerms) {
    t6 = <li><button type="button" onClick={() => handleOpenTerms(TERM_CATEGORY.MARKETING_TERMS)}>마케팅이용동의</button></li>;
    $[9] = handleOpenTerms;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== handleOpenTerms) {
    t7 = <li><button type="button" onClick={() => handleOpenTerms(TERM_CATEGORY.LOCATION_POLICY_SELECT)}>위치기반서비스 이용약관</button></li>;
    $[11] = handleOpenTerms;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t4 || $[14] !== t5 || $[15] !== t6 || $[16] !== t7) {
    t8 = <div className="flex flex-col">{t2}<ul className="flex flex-col gap-4 font-400 text-Gray-600 typo-body4">{t3}{t4}{t5}{t6}{t7}</ul></div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};
function _temp(state) {
  return state.setTermsDrawerType;
}